
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

interface TestimonialsProps {
  locationName: string;
}

const Testimonials: React.FC<TestimonialsProps> = ({ locationName }) => {
  const testimonials = [
    {
      text: `The tornado that hit Nash County damaged our roof and several neighbors'. Carolina Trophy Roofs had emergency crews out within hours and handled our insurance claim perfectly. Their local knowledge made all the difference.`,
      author: `Robert T., ${locationName}`
    },
    {
      text: "Our manufacturing facility needed emergency roof repair that couldn't wait. The Rocky Mount team worked around our production schedule and completed the job with zero downtime. Exceptional commercial service.",
      author: "Sandra K., Wilson"
    },
    {
      text: `When we restored our historic downtown building, Carolina Trophy Roofs understood exactly what was needed to maintain the architectural integrity while meeting modern standards. Outstanding craftsmanship.`,
      author: `Downtown Development Alliance, ${locationName}`
    }
  ];

  return (
    <section className="mb-12">
      <h2 className="text-3xl font-bold mb-6">Client Testimonials</h2>
      
      <div className="grid md:grid-cols-3 gap-6">
        {testimonials.map((testimonial, index) => (
          <Card key={index}>
            <CardContent className="pt-6">
              <p className="italic mb-4">
                "{testimonial.text}"
              </p>
              <p className="font-bold">- {testimonial.author}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
